module.exports = __webpack_public_path__ + "img/left-quotes-sign.f5b28174.png";